<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <div class="headline">{{ title }}</div>
      </v-card-title>
      <v-tabs v-model="tabMenu">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="resetTab">General</v-tab>
        <v-tab @click="doFetchBenefit">Benefits</v-tab>
        <v-tab v-show="showBenefitTab" @click="doFetchFactor">Benefit General And Factors</v-tab>
        <v-tab v-show="showFactorTab" @click="doFetchRate">Factor General And Rates</v-tab>
        <v-tab v-show="showRateTab">Rate General</v-tab>
        <v-tab v-show="showPremiumTab" @click="doFetchPrem">Premium</v-tab>
        <v-tab v-show="showPremiumReviewTab">Premium General</v-tab>
        <v-tab-item>
          <bus-cls-tariff-form :ids="ids"></bus-cls-tariff-form>
        </v-tab-item>
        <v-tab-item>
          <tariff-benefit-list :fetchBenefit="fetchBenefitList" :ids="ids" @resetTab="resetTab" @doReview="tariffBenefitReview" @doCreate="tariffBenefitNew"></tariff-benefit-list>
        </v-tab-item>
        <v-tab-item>
          <tariff-benefit-form :ids="ids" @resetTab="resetTab"></tariff-benefit-form>
          <tariff-factor-list v-show="!checkIsNew(ids.benefit)" :fetchFactor="fetchFactorList" :ids="ids" @resetTab="resetTab" @doReview="tariffFactorReview" @doCreate="tariffFactorNew"></tariff-factor-list>
        </v-tab-item>
        <v-tab-item>
          <tariff-factor-form :ids="ids" @resetTab="resetTab"></tariff-factor-form>
          <tariff-rate-list v-show="!checkIsNew(ids.seqNo)" :fetchRate="fetchRateList" :ids="ids" @resetTab="resetTab" @doReview="tariffRateReview" @doCreate="tariffRateNew"></tariff-rate-list>
        </v-tab-item>
        <v-tab-item>
          <tariff-rate-form :ids="ids" @resetTab="resetTab"></tariff-rate-form>
        </v-tab-item>
        <v-tab-item>
          <tariff-premium-list :fetchPrem="fetchPremList" :ids="ids" @resetTab="resetTab" @doReview="tariffPremReview" @doCreate="tariffPremNew"></tariff-premium-list>
        </v-tab-item>
        <v-tab-item>
          <tariff-premium-form :ids='ids' @resetTab="resetTab"></tariff-premium-form>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { mapActions } from 'vuex'
import BusClsTariffForm from './form/BusClsTariffForm'
import TariffBenefitList from './list/TariffBenefitList'
import TariffBenefitForm from './form/TariffBenefitForm'
import TariffFactorList from './list/TariffFactorList'
import TariffFactorForm from './form/TariffFactorForm'
import TariffRateList from './list/TariffRateList'
import TariffRateForm from './form/TariffRateForm'
import TariffPremiumList from './list/TariffPremiumList'
import TariffPremiumForm from './form/TariffPremiumForm'
export default {
  data() {
    return {
      tabMenu: 0,
      title: null,
      fetchBenefitList: false,
      fetchFactorList: false,
      fetchRateList: false,
      fetchPremList: false,
      showBenefitTab: false,
      showFactorTab: false,
      showRateTab: false,
      showPremiumTab: false,
      showPremiumReviewTab: false,
      ids: {
        busCls: null,
        tarf: null,
        benefit: null,
        benEffDate: null,
        seqNo: null,
        factEffDate: null,
        rateEffDate: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null,
        fact1Desc: null,
        fact2Desc: null,
        fact3Desc: null,
        fact4Desc: null,
        fact5Desc: null,
        fact6Desc: null,
        totTarfRate: null,
        premEffDate: null
      }
    }
  },
  watch: {
    'tariff': function (value) {
      this.ids.tarf = value
      if (value !== null) {
        this.doTitle(value)
      }
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu
    },
    busClsTariffList() {
      return this.$store.state.parameters.busCls.busClsMenu.busClsTarfList
    }
  },
  methods: {
    ...mapActions([
      'busClsMenuInit',
      'busClsTariffInit',
      'tariffBenefitInit'
    ]),
    resetTab(tab) {
      switch (tab) {
        case 1: {
          this.tabMenu = 0
          this.fetchBenefitList = false
          this.fetchFactorList = false
          this.fetchRateList = false
          this.showBenefitTab = false
          this.showFactorTab = false
          this.showRateTab = false
          this.showPremiumTab = false
          this.showPremiumReviewTab = false
          break
        }
        case 2: {
          this.tabMenu = 1
          this.fetchBenefitList = true
          this.fetchFactorList = false
          this.fetchRateList = false
          this.showBenefitTab = false
          this.showFactorTab = false
          this.showRateTab = false
          break
        }
        case 3: {
          this.tabMenu = 2
          this.fetchBenefitList = false
          this.fetchFactorList = true
          this.fetchRateList = false
          this.showBenefitTab = true
          this.showFactorTab = false
          this.showRateTab = false
          break
        }
        case 4: {
          this.tabMenu = 3
          this.fetchBenefitList = false
          this.fetchFactorList = false
          this.fetchRateList = true
          this.showBenefitTab = true
          this.showFactorTab = true
          this.showRateTab = false
          break
        }
        case 6: {
          this.tabMenu = 5
          this.fetchPremList = true
          this.showPremiumTab = true
          this.showPremiumReviewTab = false
          break
        }
        default: {
          this.tabMenu = 0
          this.fetchBenefitList = false
          this.fetchFactorList = false
          this.showBenefitTab = false
          this.showFactorTab = false
          this.showRateTab = false
          this.showPremiumTab = false
          this.showPremiumReviewTab = false
        }
      }
    },
    async doInit() {
      const expands = {
        busCls: this.id,
        tarf: this.tariff
      }
      await this.busClsTariffInit(expands)
      this.doTitle(this.tariff)
    },
    async tariffBenefitReview(data) {
      this.ids.benefit = data.benefit
      this.ids.benEffDate = data.effDate
      this.showBenefitTab = true
      this.showPremiumTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = true
      this.fetchPremList = true
      this.tabMenu = 2
    },
    async tariffFactorReview(data) {
      this.ids.seqNo = data.seqNo
      this.ids.factEffDate = data.effDate
      this.ids.fact1Desc = data.fact1
      this.ids.fact2Desc = data.fact2
      this.ids.fact3Desc = data.fact3
      this.ids.fact4Desc = data.fact4
      this.ids.fact5Desc = data.fact5
      this.ids.fact6Desc = data.fact6
      this.showFactorTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = true
      this.tabMenu = 3
    },
    async tariffRateReview(data) {
      this.ids.rateEffDate = data.effDate
      this.ids.fact1 = data.fact1
      this.ids.fact2 = data.fact2
      this.ids.fact3 = data.fact3
      this.ids.fact4 = data.fact4
      this.ids.fact5 = data.fact5
      this.ids.fact6 = data.fact6
      this.showRateTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.tabMenu = 4
    },
    async tariffPremReview(data) {
      this.ids.totTarfRate = data.totTarfRate
      this.ids.premEffDate = data.effDate
      this.fetchPremList = false
      this.showPremiumReviewTab = true
      this.tabMenu = 6
    },
    async tariffPremNew() {
      this.ids.totTarfRate = 'new'
      this.fetchPremList = false
      this.showPremiumReviewTab = true
      this.tabMenu = 6
    },
    tariffBenefitNew() {
      this.ids.benefit = 'new'
      this.showBenefitTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.tabMenu = 2
    },
    tariffFactorNew() {
      this.ids.seqNo = 'new'
      this.showFactorTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.tabMenu = 3
    },
    tariffRateNew(data) {
      this.ids.rateEffDate = 'new'
      this.ids.fact1Desc = data.factorByFact1
      this.ids.fact2Desc = data.factorByFact2
      this.ids.fact3Desc = data.factorByFact3
      this.ids.fact4Desc = data.factorByFact4
      this.ids.fact5Desc = data.factorByFact5
      this.ids.fact6Desc = data.factorByFact6
      this.showRateTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.tabMenu = 4
    },
    doFetchBenefit() {
      this.fetchBenefitList = true
      this.fetchFactorList = false
      this.fetchPremList = false
      this.showBenefitTab = false
      this.showRateTab = false
      this.showPremiumTab = false
      this.showPremiumReviewTab = false
    },
    doFetchFactor() {
      this.fetchFactorList = true
      this.fetchRateList = false
      this.showRateTab = false
      this.showFactorTab = false
      this.showPremiumReviewTab = false
    },
    doFetchRate() {
      this.fetchRateList = true
      this.showRateTab = false
      this.showPremiumReviewTab = false
    },
    doFetchPrem() {
      this.fetchPremList = true
      this.showPremiumReviewTab = false
      this.showRateTab = false
    },
    doTitle(tarf) {
      const foundTitle = this.busClsTariffList.find(item => item.value === tarf)
      this.title = foundTitle.label
    },
    checkIsNew(data) {
      if (data === 'new') {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.ids.busCls = this.id
    this.ids.tarf = this.tariff
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    tariff: {
      type: String,
      default: ''
    }
  },
  components: {
    BusClsTariffForm,
    TariffBenefitList,
    TariffBenefitForm,
    TariffFactorList,
    TariffFactorForm,
    TariffRateList,
    TariffRateForm,
    TariffPremiumList,
    TariffPremiumForm
  },
  mixins: [
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>
</style>
